export default "__VITE_ASSET__D7AOz$5W__"